export default [
  // 상품관리
  {
    code: 'ProductReviewList',
    values: {
      kr: '상품평 관리'
    }
  },
  {
    code: 'ReviewDetail',
    values: {
      kr: '상품평 상세정보'
    }
  },
  {
    code: 'ProductReportList',
    values: {
      kr: '상품평 관리'
    }
  },
  {
    code: 'ReportDetail',
    values: {
      kr: '상품평 신고 상세정보'
    }
  },
  {
    code: 'ChangeDisplayStatus',
    values: {
      kr: '전시상태 변경'
    }
  },
  {
    code: 'ChangeBestReview',
    values: {
      kr: '상품평 구분 변경'
    }
  },
  {
    code: 'DeliveryConditionGroupList',
    values: {
      kr: '배송비 관리'
    }
  },
  {
    code: 'DeliveryAreaFeeList',
    values: {
      kr: '배송비 관리'
    }
  },
  {
    code: 'DeliveryAreaFeeAdd',
    values: {
      kr: '지역별 추가배송비 추가'
    }
  },
  {
    code: 'DeliveryAreaFeeModify',
    values: {
      kr: '지역별 추가배송비 수정'
    }
  },
  {
    code: 'DeliveryWarehouseList',
    values: {
      kr: '배송비 관리'
    }
  },
  {
    code: 'Management',
    values: {
      kr: '상품재고관리'
    }
  },
  {
    code: 'StockExcelUpload',
    values: {
      kr: '엑셀 일괄등록'
    }
  },
  // 주문관리
  {
    code: 'OrderList',
    values: {
      kr: '전체주문 조회'
    }
  },
  {
    code: 'OrderListDeposit',
    values: {
      kr: '입금대기 주문'
    }
  },
  {
    code: 'OrderPayFail',
    values: {
      kr: '결제실패 주문'
    }
  },
  {
    code: 'OrderPayDone',
    values: {
      kr: '결제완료 주문'
    }
  },
  {
    code: 'OrderProductPrepare',
    values: {
      kr: '상품준비중 주문'
    }
  },
  {
    code: 'DeliveryPrepare',
    values: {
      kr: '배송준비중 주문'
    }
  },
  {
    code: 'OrderDeliverying',
    values: {
      kr: '배송중 주문'
    }
  },
  {
    code: 'OrderDeliveryDone',
    values: {
      kr: '배송완료 주문'
    }
  },
  {
    code: 'OrderBuyConfirm',
    values: {
      kr: '구매확정 주문'
    }
  },
  {
    code: 'OrderHoldByReservation',
    values: {
      kr: '예약주문 관리'
    }
  },
  {
    code: 'OrderDetail',
    values: {
      kr: '주문상세'
    }
  },
  {
    code: 'OrderFirstDiscount',
    values: {
      kr: '할인혜택 상세'
    }
  },
  {
    code: 'OrderLasttDiscount',
    values: {
      kr: '할인혜택 상세'
    }
  },
  {
    code: 'DeliveryFirstAmtDetail',
    values: {
      kr: '배송비 상세'
    }
  },
  {
    code: 'DeliveryLastAmtDetail',
    values: {
      kr: '배송비 상세'
    }
  },
  {
    code: 'ManualOrder',
    values: {
      kr: '주문상세'
    }
  },
  {
    code: 'ManualCoupon',
    values: {
      kr: '쿠폰적용'
    }
  },
  // 게시글 관리
  {
    code: 'ArticleList',
    values: {
      kr: '게시글 관리'
    }
  },
  {
    code: 'ArticleMove',
    values: {
      kr: '게시글 이동'
    }
  },
  {
    code: 'ArticleForm',
    values: {
      kr: '게시글 등록'
    }
  },
  {
    code: 'ArticleArticleNoForm',
    values: {
      kr: '게시글 수정'
    }
  },
  // 클레임관리
  // 회원관리
  {
    code: 'Recipient',
    values: {
      kr: '회원등급/그룹 선택'
    }
  },
  {
    code: 'MemberPopupCrm', //member
    values: {
      kr: '회원상세 관리'
    }
  },
  {
    code: 'MemberList',
    values: {
      kr: '회원 조회'
    }
  },
  {
    code: 'MemberGradeUpdate',
    values: {
      kr: '회원등급 변경'
    }
  },
  {
    code: 'MemberGroupUpdate',
    values: {
      kr: '회원그룹 변경'
    }
  },
  {
    code: 'MemberGiveCoupon',
    values: {
      kr: '할인쿠폰 지급'
    }
  },
  {
    code: 'MemberGrade',
    values: {
      kr: '회원등급 관리'
    }
  },
  {
    code: 'MemberGradeEvaluation',
    values: {
      kr: '회원등급평가설정'
    }
  },
  {
    code: 'MemberGiveCouponByGrade',
    values: {
      kr: '할인쿠폰 지급'
    }
  },
  {
    code: 'MemberFreeze',
    values: {
      kr: '휴면회원 조회'
    }
  },
  {
    code: 'MemberCrmBenefitDetail',
    values: {
      kr: '회원상세 관리'
    }
  },
  {
    code: 'MemberCrmSummary',
    values: {
      kr: '회원상세 관리'
    }
  },
  {
    code: 'MemberCrmMemberDetail',
    values: {
      kr: '회원상세 관리'
    }
  },
  {
    code: 'MemberCrmOrderDetail',
    values: {
      kr: '회원상세 관리'
    }
  },
  {
    code: 'MemberCrmInquiryDetail',
    values: {
      kr: '회원상세 관리'
    }
  },
  {
    code: 'MemberCrmPostDetail',
    values: {
      kr: '회원상세 관리'
    }
  },
  {
    code: 'MemberTarget',
    values: {
      kr: '회원등급/그룹 선택'
    }
  },
  {
    code: 'withdrawCoupon',
    values: {
      kr: '쿠폰 철회'
    }
  },
  // 전시관리
  {
    code: 'PopupList',
    values: {
      kr: '팝업 관리',
      jp: 'ポップアップ管理'
    }
  },
  {
    code: 'PopupDetail',
    values: {
      kr: '팝업 등록/수정'
    }
  },
  // 운영관리
  {
    code: 'SmsUsageList',
    values: {
      kr: 'SMS 관리'
    }
  },
  {
    code: 'MailUsageList',
    values: {
      kr: 'e-mail 관리'
    }
  },
  {
    code: 'TemplateList',
    values: {
      kr: 'e-mail 템플릿 선택'
    }
  },
  {
    code: 'RecipientList',
    values: {
      kr: 'e-mail 수신자 조회'
    }
  },
  {
    code: 'SmsPopupRecipientList',
    values: {
      kr: 'SMS 수신자 조회'
    }
  },
  {
    code: 'SmsSendList',
    values: {
      kr: 'SMS 관리'
    }
  },
  {
    code: 'AccumulationConfigurationModify',
    values: {
      kr: '적립금 설정'
    }
  },
  {
    code: 'AccumulationConfiguration',
    values: {
      kr: '적립금 관리'
    }
  },
  {
    code: 'AccumulationPopup',
    values: {
      kr: '일별 적립금 조회 상세'
    }
  },
  {
    code: 'PaymentListPopup',
    values: {
      kr: '적립금 지급현황'
    }
  },
  {
    code: 'DisplayGradeInfoPopup',
    values: {
      kr: '적립금 회원대상'
    }
  },
  {
    code: 'DisplayGroupInfoPopup',
    values: {
      kr: '적립금 회원대상'
    }
  },
  {
    code: 'AccumulationPayment',
    values: {
      kr: '적립금 관리'
    }
  },
  // 프로모션관리
  {
    code: 'CouponList',
    values: {
      kr: '할인쿠폰 관리'
    }
  },
  {
    code: 'AddCoupon',
    values: {
      kr: '할인쿠폰 등록'
    },
  },
  {
    code: 'FreeGiftContainer',
    values: {
      kr: '사은품 관리'
    }
  },
  {
    code: 'EditCoupon',
    values: {
      kr: '할인쿠폰 수정'
    }
  },
  {
    code: 'CouponPopupDetail',
    values: {
      kr: '할인쿠폰 지급현황'
    }
  },
  {
    code: 'CouponUseListPopup',
    values: {
      kr: '할인쿠폰 사용현황'
    }
  },
  // 기획전관리
  {
    code: 'EventList',
    values: {
      kr: '기획전 관리'
    }
  },
  // 상품섹션관리
  {
    code: 'ProductSection',
    values: {
      kr: '상품섹션 관리'
    }
  },
  // 파트너관리
  {
    code: 'PartnerList',
    values: {
      kr: '파트너 조회'
    }
  },
  {
    code: 'PartnerRegister',
    values: {
      kr: '파트너 등록'
    }
  },
  {
    code: 'PartnerNew',
    values: {
      kr: '파트너 신규 등록'
    }
  },
  {
    code: 'PartnerPoolContract',
    values: {
      kr: '파트너 검색/등록'
    }
  },
  {
    code: 'PartnerContract',
    values: {
      kr: '파트너 검색/등록'
    }
  },
  {
    code: 'PartnerPoolCopy',
    values: {
      kr: '파트너 복사등록'
    }
  },
  {
    code: 'PartnerCopy',
    values: {
      kr: '파트너 복사등록'
    }
  },
  {
    code: 'NoticeList',
    values: {
      kr: '파트너공지사항 관리'
    }
  },
  {
    code: 'SettlementList',
    values: {
      kr: '정산 현황 조회'
    }
  },
  {
    code: 'EditNotice',
    values: {
      kr: '공지사항 수정'
    }
  },
  // 서비스관리
  {
    code: 'MallList',
    values: {
      kr: '쇼핑몰 관리'
    }
  },
  {
    code: 'MallAddForm',
    values: {
      kr: '신규 쇼핑몰 등록'
    }
  },
  {
    code: 'MallEditForm',
    values: {
      kr: '쇼핑몰 수정'
    }
  },
  {
    code: 'ServiceInfo',
    values: {
      kr: '기초정보 관리'
    }
  },
  {
    code: 'HistoryPop',
    values: {
      kr: '전자금융거래이용약관 변경이력'
    }
  },
  {
    code: 'Introduction',
    values: {
      kr: '약관/개인정보처리방침 관리'
    }
  },
  {
    code: 'FaqList',
    values: {
      kr: 'shop by FAQ'
    }
  },
  {
    code: 'QueryFaq',
    values: {
      kr: 'FAQ'
    }
  },

  {
    code: 'FooterServicePrivacy',
    values: {
      kr: '개인정보처리방침'
    }
  },
  {
    code: 'FooterServicePrivacyOld',
    values: {
      kr: '개인정보처리방침'
    }
  },
  {
    code: 'default',
    values: {
      kr: 'shop by 서비스어드민'
    }
  },
  {
    code: 'GroupList',
    values: {
      kr: '권한그룹 관리'
    }
  },
  {
    code: 'GroupAddForm',
    values: {
      kr: '권한그룹 등록'
    }
  },
  {
    code: 'modifyForm',
    values: {
      kr: '권한그룹 수정'
    }
  },
  {
    code: 'Board',
    values: {
      kr: '게시판 관리'
    }
  },
  {
    code: 'AutoMail',
    values: {
      kr: 'e-mail 관리'
    }
  },
  {
    code: 'Dispatch',
    values: {
      kr: 'e-mail 관리'
    }
  },
  {
    code: 'TemplateConfig',
    values: {
      kr: 'e-mail 관리'
    }
  },
  {
    code: 'SendList',
    values: {
      kr: 'e-mail 관리'
    }
  },
  {
    code: 'SmsDispatch',
    values: {
      kr: 'SMS 관리'
    }
  },
  {
    code: 'autoSms',
    values: {
      kr: 'SMS 관리'
    }
  },
  {
    code: 'SmsTemplateConfig',
    values: {
      kr: 'SMS 관리'
    }
  },
  {
    code: 'SmsTemplateList',
    values: {
      kr: 'SMS 템플릿 선택'
    }
  },
  {
    code: 'SmsRecipientList',
    values: {
      kr: 'SMS 수신자 조회'
    }
  },
  {
    code: 'InquiryList',
    values: {
      kr: '1:1문의 관리'
    }
  },
  {
    code: 'InquiryType',
    values: {
      kr: '1:1문의 관리'
    }
  },
  {
    code: 'TypeAndAdmin',
    values: {
      kr: '문의유형/담당자 변경'
    }
  },
  {
    code: 'InquiryDetailPopup',
    values: {
      kr: '1:1문의 상세보기'
    }
  },
  {
    code: 'OrderHoldDelivery',
    values: {
      kr: '배송보류 관리'
    }
  },
  {
    code: 'NoPermission',
    values: {
      kr: 'shop by Service Admin : ErrorPage'
    }
  },
  {
    code: 'ErrorPageUnauthorized',
    values: {
      kr: 'shop by Service Admin : Error Page'
    }
  },
  {
    code: 'CsList',
    values: {
      kr: 'CS처리내역 관리'
    }
  }
];
